import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "relative a-img"
};
const _hoisted_2 = {
  class: "loading-text text-indigo-400 text-xs"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loading = _resolveComponent("Loading");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_image, _mergeProps({
    fit: "contain",
    lazy: ""
  }, {
    ..._ctx.$attrs
  }), {
    placeholder: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "text-indigo-400 animate-spin"
    }, {
      default: _withCtx(() => [_createVNode(_component_Loading)]),
      _: 1
    })]),
    _: 1
  }, 16), _createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "loadingText")])]);
}